<div class="mb-25">
  <!-- Breadcrumb removed but spacing maintained -->
</div>

<div class="add-grant-btn">
  <button mat-fab color="primary" matTooltip="Dodaj novi natječaj" (click)="goToCreateGrant()">
    <mat-icon>add</mat-icon>
  </button>
</div>

<div class="grants-container">
  @for (grant of filteredGrants; track grant) {
    <div class="col-lg-4 col-md-6 grant-card">
      <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
          <mat-card-title>
            <h5 class="mb-0">{{ grant.name }}</h5>
          </mat-card-title>
          <mat-card-subtitle></mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <p><strong>Godina natječaja:</strong> {{ grant.year }}</p>
          <p><strong>Natječaj objavio/la:</strong> {{ grant.createdBy }}</p>
          <p><strong>Datum objave:</strong> {{ grant.createdAt | date: 'd.M.yyyy. HH:mm:ss'  }}</p>
          <p><strong>Datum zadnje izmjene:</strong> {{ grant.modifiedAt | date: 'd.M.yyyy. HH:mm:ss' }}</p>
          <p><strong>Zadnji izmijenio/la:</strong> {{ grant.modifiedBy}}</p>
          <p><strong>Vrijedi do:</strong> {{ grant.validUntil | date: 'd.M.yyyy.' }}</p>
          <div>
            <p><strong>Opis natječaja:</strong></p>
            <div [innerHTML]="grant.description"></div>
          </div>
        </mat-card-content>
        <mat-card-actions>
          <button mat-icon-button color="primary" matTooltip="Uredi natječaj" (click)="goToEditGrant(grant)">
            <mat-icon>edit</mat-icon>
          </button>
          <button mat-icon-button color="warn" matTooltip="Obriši natječaj" (click)="confirmDelete(grant)">
            <mat-icon>delete</mat-icon>
          </button>
        </mat-card-actions>
      </mat-card>
    </div>
  }
</div>